import React from 'react';
import PropTypes from 'prop-types';
import clsx from '@strava/ui/clsx';
import { LinkButton } from '@strava/ui/Button';

import styles from './CallToAction.module.scss';

const CallToAction = ({
  label,
  href,
  isProcessing,
  className,
  dataCy,
  onClick
}) => {
  return (
    <LinkButton
      href={href}
      variant="primary"
      className={clsx(styles.callToAction, className)}
      data-cy={dataCy}
      onClick={onClick}
      disabled={isProcessing}
    >
      {label}
    </LinkButton>
  );
};

CallToAction.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  dataCy: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  isProcessing: PropTypes.bool
};

CallToAction.defaultProps = {
  className: undefined,
  dataCy: undefined,
  onClick: () => {},
  isProcessing: false,
  href: '/register/free'
};

export default CallToAction;
